import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Privacy Policy for Aaj Kya Banega</h1>

      <p>
        <strong>Aaj Kya Banega</strong> is committed to protecting your privacy. This policy describes how we collect,
        use, and protect information when you use our mobile application.
      </p>

      <section style={styles.section}>
        <h2>1. What Information We Collect</h2>
        <ul style={styles.list}>
          <li><strong>Mobile Number</strong></li>
        </ul>
        <p>
          We collect and verify your mobile number to create and authenticate your account using OTP-based login.
          <br />
          No email address or other personal details are required.
        </p>
        <ul style={styles.list}>
          <li><strong>Usage Data (Non-Personal)</strong></li>
        </ul>
        <p>To provide personalized meal suggestions, we collect:</p>
        <ul style={styles.list}>
          <li>Your selected preferences (e.g., veg, meal type, cuisine filters)</li>
          <li>Your interaction history (e.g., what was cooked recently)</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2>2. How We Use Your Information</h2>
        <p>Your data is used strictly to:</p>
        <ul style={styles.list}>
          <li>Authenticate and log you in using OTP</li>
          <li>Provide rule-based meal suggestions</li>
          <li>Store your saved meals and preferences</li>
          <li>Improve user experience</li>
        </ul>
        <p>We do not:</p>
        <ul style={styles.list}>
          <li>Share your mobile number or data with third parties</li>
          <li>Send promotional messages without consent</li>
          <li>Store or ask for recipes</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2>3. Meal Suggestion Logic (Rule-Based AI)</h2>
        <p>Our app uses in-app logic (no external AI providers) to suggest meals based on:</p>
        <ul style={styles.list}>
          <li>Your past meals</li>
          <li>Time of day (e.g., lunch, dinner)</li>
          <li>Selected filters (e.g., veg, healthy)</li>
        </ul>
        <p>No data is shared with external AI platforms.</p>
      </section>

      <section style={styles.section}>
        <h2>4. Data Storage & Security</h2>
        <ul style={styles.list}>
          <li>Your mobile number is securely stored and used only for login.</li>
          <li>All other data is stored anonymously and securely using MongoDB.</li>
          <li>OTP verification is handled securely via an SMS gateway provider.</li>
          <li>We implement industry-standard encryption and access control.</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2>5. Third-Party Services</h2>
        <p>We may use third-party services for:</p>
        <ul style={styles.list}>
          <li>OTP authentication (e.g., Firebase and Twilio)</li>
          <li>Anonymous analytics (optional, not tied to personal data)</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2>6. Children’s Privacy</h2>
        <p>The app is not intended for users under the age of 13. We do not knowingly collect data from children.</p>
      </section>

      <section style={styles.section}>
        <h2>7. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy to reflect changes in technology or legal requirements. The latest version
          will always be available in the app.
        </p>
      </section>

      <section style={styles.section}>
        <h2>8. Contact Us</h2>
        <div style={styles.contactBox}>
          <p>If you have questions about our Privacy Policy or data practices, reach out to:</p>
          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:contact@aajkyabanega.com" style={styles.link}>contact@aajkyabanega.com</a>
          </p>
        </div>
      </section>
    </div>
  );
};

// Inline styles
const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    lineHeight: 1.6,
    margin: 40,
    backgroundColor: '#f9f9f9',
    color: '#333',
  },
  heading: {
    color: '#2c3e50',
  },
  section: {
    marginBottom: 30,
  },
  list: {
    listStyleType: 'none',
    paddingLeft: 0,
  },
  contactBox: {
    backgroundColor: '#ecf0f1',
    padding: 15,
    borderLeft: '5px solid #3498db',
  },
  link: {
    color: '#2980b9',
    textDecoration: 'none',
  }
};

export default PrivacyPolicy;
